
(() => {
  const script = document.currentScript;
  const root = script?.closest('.tp-product');
  if (!root) return;

  const productEl = root.querySelector('[data-tp-product]');
  if (!productEl) return;

  let product;
  try {
    product = JSON.parse(productEl.textContent);
  } catch (error) {
    console.error('Unable to read product data.', error);
    return;
  }

  const money = cents => {
    try {
      return new Intl.NumberFormat(
        document.documentElement.lang || 'en-US',
        {
          style: 'currency',
          currency: window.Shopify?.currency?.active || 'USD'
        }
      ).format(cents / 100);
    } catch (error) {
      return '$' + (cents / 100).toFixed(2);
    }
  };

  const variantInput = root.querySelector('[data-tp-variant-id]');
  const priceEl = root.querySelector('[data-tp-price]');
  const compareEl = root.querySelector('[data-tp-compare]');
  const savingsEl = root.querySelector('[data-tp-savings]');
  const addBtn = root.querySelector('[data-tp-add]');
  const stickyBtn = root.querySelector('[data-tp-sticky]');
  const stickyPrice = root.querySelector('[data-tp-sticky-price]');

  const slides = [...root.querySelectorAll('[data-tp-slide]')];
  const thumbs = [...root.querySelectorAll('[data-tp-thumb]')];
  const currentEl = root.querySelector('[data-tp-current]');

  let current = Math.max(0, slides.findIndex(slide => !slide.hidden));

  const selectedVariant = () => {
    const selected = {};

    root.querySelectorAll('[data-tp-option]').forEach(button => {
      if (button.classList.contains('is-selected')) {
        selected[button.dataset.tpOption] = button.dataset.tpValue;
      }
    });

    return product.variants.find(variant =>
      Object.keys(selected).every(position =>
        variant.options[Number(position) - 1] === selected[position]
      )
    ) || product.variants[0];
  };

  const showSlide = index => {
    if (!slides.length) return;

    current = (index + slides.length) % slides.length;

    slides.forEach((slide, i) => {
      slide.hidden = i !== current;
      slide.classList.toggle('is-active', i === current);
    });

    thumbs.forEach((thumb, i) => {
      thumb.classList.toggle('is-active', i === current);
      thumb.setAttribute(
        'aria-current',
        i === current ? 'true' : 'false'
      );
    });

    if (currentEl) {
      currentEl.textContent = String(current + 1);
    }
  };

  // Switch the gallery to the image linked to the selected variant.
  const showVariantImage = variant => {
    if (!variant || !slides.length) return;

    const mediaId = variant.featured_media?.id;

    if (mediaId == null) return;

    const index = slides.findIndex(slide =>
      String(slide.dataset.tpSlide || '') === String(mediaId)
    );

    if (index !== -1) {
      showSlide(index);
    }
  };

  const updateVariant = () => {
    const variant = selectedVariant();
    if (!variant) return;

    if (variantInput) variantInput.value = variant.id;

    if (priceEl) {
      priceEl.textContent = money(variant.price);
    }

    if (stickyPrice) {
      stickyPrice.textContent = money(variant.price);
    }

    const onSale =
      variant.compare_at_price &&
      variant.compare_at_price > variant.price;

    if (compareEl) {
      compareEl.hidden = !onSale;
      compareEl.textContent = onSale
        ? 'reg ' + money(variant.compare_at_price)
        : '';
    }

    if (savingsEl) {
      savingsEl.hidden = !onSale;
      savingsEl.textContent = onSale
        ? money(variant.compare_at_price - variant.price) + ' off'
        : '';
    }

    if (addBtn) {
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available
        ? addBtn.dataset.addLabel
        : addBtn.dataset.soldLabel;
    }

    if (stickyBtn) {
      stickyBtn.disabled = !variant.available;
    }

    // Update the main image and thumbnail selection.
    showVariantImage(variant);

    // Update the selected variant in the URL.
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  };

  root.querySelectorAll('[data-tp-option]').forEach(button => {
    button.addEventListener('click', () => {
      const position = button.dataset.tpOption;

      root.querySelectorAll(
        `[data-tp-option="${position}"]`
      ).forEach(optionButton => {
        optionButton.classList.remove('is-selected');
        optionButton.setAttribute('aria-pressed', 'false');
      });

      button.classList.add('is-selected');
      button.setAttribute('aria-pressed', 'true');

      updateVariant();
    });
  });

  thumbs.forEach((thumb, index) => {
    thumb.addEventListener('click', () => showSlide(index));
  });

  root.querySelector('[data-tp-prev]')
    ?.addEventListener('click', () => showSlide(current - 1));

  root.querySelector('[data-tp-next]')
    ?.addEventListener('click', () => showSlide(current + 1));

  stickyBtn?.addEventListener('click', () => addBtn?.click());

  root.querySelectorAll('[data-tp-tab]').forEach(tab => {
    tab.addEventListener('click', () => {
      const name = tab.dataset.tpTab;

      root.querySelectorAll('[data-tp-tab]').forEach(item => {
        item.classList.toggle('is-active', item === tab);
      });

      root.querySelectorAll('[data-tp-panel]').forEach(panel => {
        panel.hidden = panel.dataset.tpPanel !== name;
        panel.classList.toggle(
          'is-active',
          panel.dataset.tpPanel === name
        );
      });
    });
  });

  root.querySelector('[data-tp-list]')?.addEventListener('click', () => {
    alert('Connect this button to your wishlist app or customer account.');
  });

  // Initialize product information and the selected variant image.
  updateVariant();
})();
